import axios from 'axios';

const sendHelpEmail = (message) => {
  return axios.post('contacts/help', {message});
};

export default{
  sendHelpEmail
};
